import { Color } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { EquityOfferEntityNormalized } from '../../../../../../../../../store/product/types';
import { EquityPendingSubscribeItem } from '../../../../../../../../NewApplication/Product/components/Equity/Item/components/PendingSubscribe';

import { EquityListItemDesktop } from './desktop';
import { EquityListItemMobile } from './mobile';
import { EquityListItemTablet } from './tablet';

export namespace EquityListItemTypes {
  export type OrderType = 'Limit' | 'Market';

  export interface Props {
    offer: EquityOfferEntityNormalized;
  }
}

export const EQUITY_ORDER_TYPE_OPTIONS = [
  { label: 'LIMITADA', value: 'Limit' },
  { label: 'A MERCADO', value: 'Market' },
];

export const EQUITY_ORDER_TYPE_LABEL: Record<EquityListItemTypes.OrderType, string> = {
  Limit: 'LIMITADA',
  Market: 'A MERCADO',
};

export const EquityListItem: React.FC<EquityListItemTypes.Props> = ({ offer }) => {
  const productItemIsSubscribed = offer.quote.subscribeStatus.statusId === 3;

  const equityListItem = useBreakpointValue({
    base: <EquityListItemMobile offer={offer} />,
    sm: <EquityListItemTablet offer={offer} />,
    lg: <EquityListItemDesktop offer={offer} />,
  });

  if (!productItemIsSubscribed) {
    const {
      productNameNormalized: productName,
      imageNormalized: image,
      symbolNormalized: symbol,
      productIdNormalized: productId,
    } = offer;

    return (
      <EquityPendingSubscribeItem
        {...{
          productId,
          lateralBarColor: Color['product.rendavariavelbuy'],
          image,
          productName,
          symbol,
        }}
      />
    );
  }

  return equityListItem;
};
